import React from "react";
import { Currency } from "swan-public-api-client";
import { FormattedNumber } from "react-intl";

interface Props {
  value: number | null | undefined;
  currency: Currency | null | undefined;
}

export class FormattedPrice extends React.PureComponent<Props> {
  public render() {
    if (this.props.value === undefined
      || this.props.value === null) {
      return ("–");
    }

    if (this.props.currency !== undefined
      && this.props.currency !== null) {
      return (<FormattedNumber value={this.props.value} minimumFractionDigits={this.props.currency.Exponent} maximumFractionDigits={this.props.currency.Exponent} />);
    } else {
      return (<FormattedNumber value={this.props.value} minimumFractionDigits={8} maximumFractionDigits={8} />);
      // return (<FormattedNumber value={this.props.value} minimumFractionDigits={0} maximumFractionDigits={20} />); // if we don't know the currency, the best we can do is make sure we don't truncate the values
    }
  }
}
